<template>
  <div class="skeleton-item" :style="style" aria-label="loading">
    loading...
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  width: { type: Number, required: false, default: null },
  height: { type: Number, required: false, default: null },
  radius: { type: Number, required: false, default: null },
});

const style = computed(() => ({
  'width': `${props.width}px` || null,
  'height': `${props.height}px` || null,
  'border-radius': `${props.radius}px` || null,
}));
</script>

<style lang="scss">
@import '@/stylesheets/global';

.skeleton-item {
  color: transparent;
  background: linear-gradient(270deg, transparent, map-get($background-color, lightest));
  background-size: 400% 400%;
  -webkit-animation: SkeletonPulse 1.6s ease infinite;
  -moz-animation: SkeletonPulse 1.6s ease infinite;
  animation: SkeletonPulse 1.6s ease infinite;
}

@-webkit-keyframes SkeletonPulse {
  0% { background-position: 0% 50% }
  50% { background-position: 100% 50% }
  100% { background-position: 0% 50% }
}
@-moz-keyframes SkeletonPulse {
  0% { background-position: 0% 50% }
  50% { background-position: 100% 50% }
  100% { background-position: 0% 50% }
}
@keyframes SkeletonPulse {
  0% { background-position: 0% 50% }
  50% { background-position: 100% 50% }
  100% { background-position: 0% 50% }
}
</style>
